export class FormTemplate {
  /**
   *
   */
  public formId: number;

  /**
   *
   */
  public title: string;

  /**
   *
   */
  public config: Record<string, unknown>;

  /**
   *
   */
  public configLines: Record<string, unknown>;

  /**
   *
   */
  public linkFormStatusToResult: boolean;

  /**
   *
   */
  // TODO:  Set up the correct type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public deletedFieldIds: any[];

  /**
   * Creates an instance of FormTemplate.
   *
   * @param formTemplate the json data
   */
  // TODO:  Set up the correct type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public constructor(formTemplate: any) {
    this.formId = formTemplate.formId;
    this.title = formTemplate.title;
    this.config = formTemplate.config;
    this.configLines = formTemplate.configLines;
    this.linkFormStatusToResult = formTemplate.linkFormStatusToResult;
    this.deletedFieldIds = formTemplate.deletedFieldIds;
  }
}
